import React, { useEffect } from "react";
import { Card } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { updateProfile } from "../../../../middleware/dynamicProfileRender";
import DeleteModal from "../DeleteModal/delete";
import SkillsEditModal from "./skills";
import { getEmployee } from "../../../../../../api/services/default/employee";
import { useQuery } from "@tanstack/react-query";
import { Skeleton } from "@material-ui/lab";

const Skills = (props) => {
  const [modalShow, setModalShow] = React.useState(false);
  const [modalShowDel, delModalShow] = React.useState(false);
  const { employeeID , isPersonal} = props;
  const [index, setIndex] = React.useState(undefined);
  const { data : employeeData = {} } = useQuery({
    queryKey: ["getEmployee", employeeID],
    queryFn: () => getEmployee(employeeID),
    enabled: !!employeeID,
  })
  useEffect(() => {}, [employeeData]);
  const handleEdit = (idx) => {
    setModalShow(true);
    setIndex(idx);
  };

  const handleAdd = () => {
    setModalShow(true);
    setIndex(undefined);
  };

  const dispatch = useDispatch();

  const handleDelete = (idx) => {
    delModalShow(true);
    setIndex(idx);
  };

  const handleDeleteData = (index) => {
    if (index > -1) {
      employeeData?.skills?.splice(index, 1);
    }
    delModalShow(false);
    let skills = employeeData?.skills?.map((item) => item);
    const payload = {
      skills,
    };
    setModalShow(false);
    dispatch(updateProfile(payload, employeeID, payload));
  };
  return (
    <>
         {Object.values(employeeData).length ? (
    <>
      <SkillsEditModal
        show={modalShow}
        employeeid={employeeID}
        skillsdata={employeeData?.skills}
        idx={index}
        onHide={() => setModalShow(false)}
      />
      <DeleteModal
        show={modalShowDel}
        index={index}
        handleDelete={() => handleDeleteData(index)}
        onHide={() => delModalShow(false)}
      />
      <Card>
        <Card.Body>
          <div className="d-flex justify-content-between">
            <h5 className="card-title mb-3 header-title">Skills</h5>
            {
              isPersonal?
              <></>
              :
              <Link
              to="#"
              className="linkbtn me-1 mt-0"
              onClick={() => handleAdd()}
            >
              <i className="fa-solid fa-square-plus fs-17"></i>
            </Link>
            }
           
          </div>
          <div className="emplbg">
            <div className="d-block d-lg-flex justify-content-between my-1">
              <div className="listskills">
                {employeeData?.skills?.map((res, idx) => {
                  return (
                    <div>
                      <div className="skills">
                        <span>{res?.skill} </span>
                        {
                          isPersonal?
                          <></>
                          :
                          <>
                        <Link to="#" onClick={() => handleEdit(idx)} className="px-2">
                          <i className="fa-solid fa-pen fs-17"></i>
                        </Link>
                        <Link
                          to="#"
                          style={{ color: "#F05C50" }}
                          className="mr-4"
                          onClick={() => handleDelete(idx)}
                        >
                          <i className="fa-regular fa-trash-can fs-17"></i>
                        </Link>
                          </>
                        }  
                        </div>
                      <div className="d-flex mt-2 mt-lg-0"></div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </>
      ) : (
        <Skeleton variant="rounded" height={260} />
    )}
    </>
  );
};
export default Skills;
